import React, { Component } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import withStyles from '@material-ui/styles/withStyles';
import 'react-notifications/lib/notifications.css';
import {ChevronRightTwoTone, SchoolTwoTone} from "@material-ui/icons";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import {search} from "../../util/ApiUtils";
import Pagination from "@material-ui/lab/Pagination";

function convert(fullTerm) {
    let searchWord = sessionStorage.getItem("searchTerm");
    let fromIndex = fullTerm.indexOf(searchWord);
    let toIndex = fromIndex + searchWord.length;
    if (fromIndex >= 50) {
        fromIndex = fromIndex - 50;
    }
    if ((fullTerm.length - toIndex) > 50) {
        toIndex = toIndex + 50;
    } else {
        toIndex = fullTerm.length - 1;
    }
    return fullTerm.substring(fromIndex, toIndex).split('||').join('').trim();
}

function refreshPage(smth) {
    window.location = smth;
    //window.location.replace("http://localhost:3000/#/planning/legal-requirements");
    return true;
}

const classes = (theme => ({
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
        },
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

class SearchResults extends Component {
    constructor(props) {
        super(props);
        let searchTerm = sessionStorage.getItem('searchTerm');
        console.log('searchTerm', searchTerm);
        this.state = {
            currentUser: null,
            isAuthenticated: false,
            isLoading: false,
            searchTerm: searchTerm,
            showSearchResults: false,
        };
        this.loadResults = this.loadResults.bind(this);
    }

    componentDidMount() {
        this.loadResults();
    }

    loadResults() {
        console.log('reloading', this.state.searchTerm);
        if (this.state.searchTerm && this.state.searchTerm !== '') {
            search(this.state.searchTerm)
                .then(response => {
                    console.log('response', response);
                    this.setState({
                        searchResults: response.data,
                        lastSearchTerm: this.state.searchTerm,
                        from: 0,
                        to: 10,
                    });
                })
                .catch(error => {
                    console.log('error', error);
                });
        }
    }

    render() {
        const { classes } = this.props;

        const handleChange = (event, value) => {
            console.log('event', event);
            console.log('value', value);
            this.setState({
                from: value * 10 - 10,
                to: value * 10,
            })
        };

        return (
            <div>
                <Container component="main" maxWidth="md">
                    <CssBaseline />
                    <div className={classes.paper}>
                        <Typography variant="h5" paragraph>
                            Search Results for <b>{this.state.lastSearchTerm}</b>:
                        </Typography>
                        <List>
                            {(this.state.searchResults && this.state.searchResults.length > 0) ? this.state.searchResults.slice(this.state.from, this.state.to).map(function(item) {
                                return <ListItem key={item.id} style={{padding: '0px'}} button={true} {...{ onClick: () => refreshPage(`/#${item.link}`) }}>
                                    <ListItemIcon><ChevronRightTwoTone htmlColor="#008000"/></ListItemIcon>
                                    <ListItemText primary={ convert(item.term) }/>
                                </ListItem>;
                            }) : <div>No results found</div>}
                        </List>
                        {this.state.searchResults && this.state.searchResults.length > 10 && <Pagination count={Math.floor(this.state.searchResults.length/10) + 1} onChange={handleChange}/>}
                    </div>
                </Container>
            </div>
        );
    }
}

export default withStyles(classes)(SearchResults);